<script setup>
// TODO(VHA): Rename to EnIconWrapper.vue and move one level up
import { computed } from 'vue';

import EnIconAccounts from 'Components/icons/navigation/EnIconAccounts.vue';
import EnIconCustomer from 'Components/icons/navigation/EnIconCustomer.vue';
import EnIconDashboard from 'Components/icons/navigation/EnIconDashboard.vue';
import EnIconDevelopment from 'Components/icons/navigation/EnIconDevelopment.vue';
import EnIconEnCount from 'Components/icons/navigation/EnIconEnCount.vue';
import EnIconEnFlow from 'Components/icons/navigation/EnIconEnFlow.vue';
import EnIconEntab from 'Components/icons/navigation/EnIconEntab.vue';
import EnIconLogout from 'Components/icons/navigation/EnIconLogout.vue';
import EnIconOther from 'Components/icons/navigation/EnIconOther.vue';
import EnIconRentalData from 'Components/icons/navigation/EnIconRentalData.vue';
import EnIconTools from 'Components/icons/navigation/EnIconTools.vue';
import EnIconUser from 'Components/icons/navigation/EnIconUser.vue';
import EnRocketIcon from 'Components/icons/EnRocketIcon.vue';

import { NavigationIcons } from 'Components/icons/navigation/enIcons';
import { Icons } from 'Components/icons/EnIcons';

const props = defineProps({
  /**
   * Icon to be displayed.
   * Of enum NavigationIcons or Icons.
   */
  icon: String,
});

const iconComponent = computed(() => {
  switch (props.icon) {
    case NavigationIcons.ACCOUNTS:
      return EnIconAccounts;
    case NavigationIcons.CUSTOMER:
      return EnIconCustomer;
    case NavigationIcons.DASHBOARD:
      return EnIconDashboard;
    case NavigationIcons.DEVELOPMENT:
      return EnIconDevelopment;
    case NavigationIcons.ENCOUNT:
      return EnIconEnCount;
    case NavigationIcons.ENFLOW:
      return EnIconEnFlow;
    case NavigationIcons.ENTAB:
      return EnIconEntab;
    case NavigationIcons.LOGOUT:
      return EnIconLogout;
    case NavigationIcons.OTHER:
      return EnIconOther;
    case NavigationIcons.RENTALDATA:
      return EnIconRentalData;
    case NavigationIcons.TOOLS:
      return EnIconTools;
    case NavigationIcons.USER:
      return EnIconUser;
    case Icons.ROCKET:
      return EnRocketIcon;
  }
});
</script>

<template>
  <component :is="iconComponent"></component>
</template>

<style scoped lang="scss">
</style>